import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from'./NewDeveloper.module.css';
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";

class NewDeveloper extends Component  {
    state = {
        developers: [],
        game_developer: {
            game_developer_id: null,
            game_developer_name: '',
            game_developer_notes: ''
        }
    };

    componentDidMount() {
        if (this.props.developers !== []) {
            this.setState({developers: this.props.developers});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
        this.props.newDeveloperToggle();
    };

    postDataHandler = () => {
        const post = {
            "game_developer_id": this.state.game_developer.game_developer_id,
            "game_developer_name": this.state.game_developer.game_developer_name,
            "game_developer_notes": this.state.game_developer.game_developer_notes,
        };
        axios.post(apiUrl +'Developers/set', post)
            .then(response => {
                this.props.onNewDeveloper(response.data);
            });
        this.setState({
            "game_developer": {
                game_developer_id: null,
                game_developer_name: '',
                game_developer_notes: ''
            }
        });

    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewDevelopersBlock}>
                    <div>
                        <Form.Control
                            type="text"
                            placeholder="Enter the name of the developer you want to create."
                            value={this.state.game_developer.game_developer_name}
                            onChange={(event) => this.setState({game_developer: {...this.state.game_developer, game_developer_name: event.target.value}})}
                        />
                        <Form.Control
                            as="textarea"
                            rows="4"
                            placeholder="Include a paragraph or so long description of the developer."
                            value={this.state.game_developer.game_developer_notes}
                            onChange={(event) => this.setState({game_developer: {...this.state.game_developer, game_developer_notes: event.target.value}})}
                        />
                    </div>
                    <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newDeveloperToggle}>Cancel</Button>
                    <Button className="col-sm-3" variant="outline-primary" onClick={
                        this.addHandler
                    }>Submit</Button>
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewDeveloper;